import type { EaMatch } from "./types";
import { ourClubIdOf } from "../../lib/ea-game";

export function aggregateMatchesStats(matches: EaMatch[], eaClubId: string) {
  let wins = 0, draws = 0, losses = 0, goalsFor = 0, goalsAgainst = 0, ratingSum = 0, ratingCount = 0;
  let cleanSheets = 0;
  const playerAgg = new Map<string, { name: string; pos: string; matches: number; goals: number; assists: number; mom: number; ratingSum: number; ratingCount: number; saves: number; cleanSheets: number; tackles: number; passes: number; passAttempts: number; shots: number }>();

  for (const m of matches) {
    const d = m.data || {};
    const ourId = ourClubIdOf(d, eaClubId);
    const clubs = d.clubs || {};
    const ourClub = clubs[ourId];
    const oppId = Object.keys(clubs).find((id) => id !== ourId);
    const oppClub = oppId ? clubs[oppId] : null;
    if (!ourClub || !oppClub) continue;
    const ourGoals = Number(ourClub.goals || 0);
    const oppGoals = Number(oppClub.goals || 0);
    goalsFor += ourGoals;
    goalsAgainst += oppGoals;
    if (ourGoals > oppGoals) wins++;
    else if (ourGoals < oppGoals) losses++;
    else draws++;
    if (oppGoals === 0) cleanSheets++;

    const players = (d.players || {})[ourId] || {};
    for (const pid of Object.keys(players)) {
      const p = players[pid];
      const key = String(p.playername || pid);
      const cur = playerAgg.get(key) || {
        name: key,
        pos: p.pos || "—",
        matches: 0,
        goals: 0,
        assists: 0,
        mom: 0,
        ratingSum: 0,
        ratingCount: 0,
        saves: 0,
        cleanSheets: 0,
        tackles: 0,
        passes: 0,
        passAttempts: 0,
        shots: 0,
      };
      cur.matches += 1;
      cur.goals += Number(p.goals || 0);
      cur.assists += Number(p.assists || 0);
      cur.mom += Number(p.mom || 0);
      const r = Number(p.rating || 0);
      if (r > 0) { cur.ratingSum += r; cur.ratingCount += 1; ratingSum += r; ratingCount += 1; }
      cur.saves += Number(p.saves || 0);
      cur.cleanSheets += Number(p.cleansheetsany || 0);
      cur.tackles += Number(p.tacklesmade || 0);
      cur.passes += Number(p.passesmade || 0);
      cur.passAttempts += Number(p.passattempts || 0);
      cur.shots += Number(p.shots || 0);
      playerAgg.set(key, cur);
    }
  }

  const avgRating = ratingCount > 0 ? ratingSum / ratingCount : 0;
  const total = matches.length;
  const winPct = total > 0 ? Math.round((wins / total) * 100) : 0;
  const playersList = Array.from(playerAgg.values());

  return {
    total,
    wins,
    draws,
    losses,
    goalsFor,
    goalsAgainst,
    cleanSheets,
    winPct,
    avgRating,
    players: playersList,
  };
}
